import InputGroup from './InputGroup';
export default InputGroup;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-input-group/src/index.js